<template>
  <section class="dashboard section is-full-touch is-full mobile">
    <div class="container is-fluid-desktop is-full-touch is-full-mobile">
      <div class="is-hidden-desktop is-hidden-widescreen">
        <Mobilemenu />
      </div>
      <div class="columns">
        <div
            class="column is-narrow-desktop is-hidden-mobile is-hidden-touch sbar"
        >
          <Sidebar />
        </div>
        <div class="column">
          <div class="block">
            <h1 class="title block">Discount</h1>
            <h2 class="subtitle block">
              Change discount settings here
            </h2>
          </div>
          <div class="block">
            <button @click="toggleDiscount()" class="button is-primary">{{ discountStatus }} discount</button>
          </div>
          <div v-if="discount" class="plan box block">
            <div class="field">
              <label class="label">Discount %</label>
              <div class="control">
                <input
                    v-model.number="discount.discountPercent"
                    class="input"
                    placeholder="Set discount % here"
                    type="number"
                />
              </div>
            </div>

            <div class="field is-grouped">
              <div class="control">
                <button @click="updateDiscountPercent" class="button is-link">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import {db} from "@/firebase";
import Mobilemenu from "@/components/Mobilemenu";
import AccountService from "../services/AccountService";

export default {
  name: "SettingsDiscountView",
  components: {
    Sidebar,
    Mobilemenu
  },
  data() {
    return {
      discount: null,
    }
  },
  firestore: {
    discount: db.collection('settings').doc('discount')
  },
  computed: {
    discountStatus() {
      if (this.discount) {
        return this.discount.enabled ? 'Disable' : 'Enable'
      } else {
        return 'Error'
      }
    }
  },
  methods: {
    async toggleDiscount() {
      try {
        await this.$firestoreRefs.discount.update({
          enabled: !this.discount.enabled
        })
        alert('Updated');
      } catch (e) {
        console.log(e)
      }
    },
    async updateDiscountPercent() {
      try {
        await this.$firestoreRefs.discount.update({
          discountPercent: this.discount.discountPercent
        })
        alert('Updated');
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>
